import { ChevronDown } from "lucide-react";

export const ExpandToggle = ({ total, open, onToggle, testid, limit = 15 }) =>
  total > limit ? (
    <button onClick={onToggle} data-testid={testid}
      className="mt-4 flex w-full items-center justify-center gap-1 text-xs text-muted-foreground transition-colors hover:text-foreground">
      {open ? "Mostra meno" : `Mostra tutte (${total})`}
      <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
    </button>
  ) : null;
